<!-- 主题设置抽屉 license by http://eleadmin.com -->
<template>
  <el-drawer
    size="300px"
    :visible="visible"
    :append-to-body="true"
    :title="t('ele.setting.title')"
    @update:visible="updateVisible"
  >
    <div :class="['ele-setting-wrapper', { 'ele-setting-dark': darkMode }]">
      <!-- 侧栏风格设置 -->
      <div class="ele-setting-theme ele-text-primary">
        <el-tooltip :content="t('ele.setting.sideStyles.dark')" placement="top">
          <div class="ele-bg-base ele-side-dark" @click="setSideStyle('dark')">
            <i class="el-icon-check" v-if="sideStyle === 'dark'"></i>
          </div>
        </el-tooltip>
        <el-tooltip
          :content="t('ele.setting.sideStyles.light')"
          placement="top"
        >
          <div class="ele-bg-base" @click="setSideStyle('light')">
            <i class="el-icon-check" v-if="sideStyle === 'light'"></i>
          </div>
        </el-tooltip>
      </div>
      <!-- 顶栏风格设置 -->
      <div class="ele-setting-theme ele-text-primary">
        <el-tooltip
          :content="t('ele.setting.headStyles.light')"
          placement="top"
        >
          <div
            class="ele-bg-base ele-head-light"
            @click="setHeadStyle('light')"
          >
            <i class="el-icon-check" v-if="headStyle === 'light'"></i>
          </div>
        </el-tooltip>
        <el-tooltip :content="t('ele.setting.headStyles.dark')" placement="top">
          <div class="ele-bg-base ele-head-dark" @click="setHeadStyle('dark')">
            <i class="el-icon-check" v-if="headStyle === 'dark'"></i>
          </div>
        </el-tooltip>
        <el-tooltip
          :content="t('ele.setting.headStyles.primary')"
          placement="top"
        >
          <div
            class="ele-bg-base ele-head-primary"
            @click="setHeadStyle('primary')"
          >
            <div class="ele-bg-primary"></div>
            <i class="el-icon-check" v-if="headStyle === 'primary'"></i>
          </div>
        </el-tooltip>
      </div>
      <!-- 主题颜色设置 -->
      <div
        v-if="typeof themes !== 'undefined' && themes !== null"
        class="ele-setting-colors"
      >
        <template v-if="themes.length">
          <el-tooltip
            v-for="(d, i) in themes"
            :key="i"
            :content="d.name"
            placement="top"
          >
            <div
              class="ele-setting-color-item"
              :style="{ 'background-color': d.color || d.value }"
              @click="changeColor(d.value)"
            >
              <i
                class="el-icon-check"
                v-if="d.value ? d.value === color : !color"
              ></i>
            </div>
          </el-tooltip>
        </template>
        <template v-else>
          <el-tooltip
            v-for="(d, i) in defaultThemes"
            :key="i"
            placement="top"
            :content="t('ele.setting.colors.' + d.name)"
          >
            <div
              class="ele-setting-color-item"
              :style="{ 'background-color': d.color || d.value }"
              @click="changeColor(d.value)"
            >
              <i
                class="el-icon-check"
                v-if="d.value ? d.value === color : !color"
              ></i>
            </div>
          </el-tooltip>
        </template>
        <!-- 颜色选择器 -->
        <el-color-picker
          v-if="colorPicker"
          v-model="chooseColor"
          :predefine="predefineColors"
          class="ele-setting-color-picker"
          @change="changeColor"
        />
      </div>
      <!-- 暗黑模式开关 -->
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.darkMode') }}</div>
        <div class="setting-item-control">
          <el-switch :value="darkMode" @change="setDarkMode" />
        </div>
      </div>
      <el-divider />
      <!-- 导航模式设置 -->
      <div class="ele-setting-title ele-text-secondary">{{
        t('ele.setting.layoutStyle')
      }}</div>
      <div class="ele-setting-theme ele-text-primary">
        <el-tooltip
          :content="t('ele.setting.layoutStyles.side')"
          placement="top"
        >
          <div
            class="ele-bg-base ele-side-dark"
            @click="setLayoutStyle('side')"
          >
            <i class="el-icon-check" v-if="layoutStyle === 'side'"></i>
          </div>
        </el-tooltip>
        <el-tooltip
          :content="t('ele.setting.layoutStyles.top')"
          placement="top"
        >
          <div class="ele-bg-base ele-head-dark" @click="setLayoutStyle('top')">
            <i class="el-icon-check" v-if="layoutStyle === 'top'"></i>
          </div>
        </el-tooltip>
        <el-tooltip
          :content="t('ele.setting.layoutStyles.mix')"
          placement="top"
        >
          <div
            class="ele-bg-base ele-layout-mix"
            @click="setLayoutStyle('mix')"
          >
            <i class="el-icon-check" v-if="layoutStyle === 'mix'"></i>
          </div>
        </el-tooltip>
      </div>
      <!-- 侧栏双菜单开关 -->
      <div class="ele-setting-item">
        <div class="setting-item-title">{{
          t('ele.setting.sideMenuStyle')
        }}</div>
        <div class="setting-item-control">
          <el-switch
            :value="sideMenuStyle === 'mix'"
            @change="setSideMenuStyle"
          />
        </div>
      </div>
      <!-- 内容全屏开关 -->
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.bodyFull') }}</div>
        <div class="setting-item-control">
          <el-switch :value="bodyFull" @change="setBodyFull" />
        </div>
      </div>
      <!-- 其它配置 -->
      <el-divider />
      <div class="ele-setting-title ele-text-secondary">{{
        t('ele.setting.other')
      }}</div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.fixedHeader') }}</div>
        <div class="setting-item-control">
          <el-switch :value="fixedHeader" @change="setFixedHeader" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{
          t('ele.setting.fixedSidebar')
        }}</div>
        <div class="setting-item-control">
          <el-switch :value="fixedSidebar" @change="setFixedSidebar" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.fixedBody') }}</div>
        <div class="setting-item-control">
          <el-switch :value="fixedBody" @change="setFixedBody" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{
          t('ele.setting.logoAutoSize')
        }}</div>
        <div class="setting-item-control">
          <el-switch :value="logoAutoSize" @change="setLogoAutoSize" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{
          t('ele.setting.colorfulIcon')
        }}</div>
        <div class="setting-item-control">
          <el-switch :value="colorfulIcon" @change="setColorfulIcon" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{
          t('ele.setting.sideUniqueOpen')
        }}</div>
        <div class="setting-item-control">
          <el-switch :value="sideUniqueOpen" @change="setSideUniqueOpen" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.showFooter') }}</div>
        <div class="setting-item-control">
          <el-switch :value="showFooter" @change="setShowFooter" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.weakMode') }}</div>
        <div class="setting-item-control">
          <el-switch :value="weakMode" @change="setWeakMode" />
        </div>
      </div>
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.showTabs') }}</div>
        <div class="setting-item-control">
          <el-switch :value="showTabs" @change="setShowTabs" />
        </div>
      </div>
      <!-- 多页签风格 -->
      <div class="ele-setting-item">
        <div class="setting-item-title">{{ t('ele.setting.tabStyle') }}</div>
        <div class="setting-item-control">
          <el-select size="mini" :value="tabStyle" @change="setTabStyle">
            <el-option
              :label="t('ele.setting.tabStyles.default')"
              value="default"
            />
            <el-option :label="t('ele.setting.tabStyles.dot')" value="dot" />
            <el-option :label="t('ele.setting.tabStyles.card')" value="card" />
          </el-select>
        </div>
      </div>
      <!-- 文字提示 -->
      <el-divider v-if="tipsVisible || resetButton" />
      <el-alert
        v-if="tipsVisible"
        type="warning"
        :closable="false"
        class="ele-alert-border"
        :title="tips || t('ele.setting.tips')"
      />
      <div class="ele-setting-button-group">
        <el-button
          v-if="resetButton"
          size="small"
          class="ele-fluid"
          icon="el-icon-refresh-left"
          @click="resetSetting"
        >
          重置
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
  import Locale from 'element-ui/lib/mixins/locale';
  // 默认主题色
  const DEFAULT_THEMES = [
    {
      name: 'default',
      value: null,
      color: '#1890ff'
    },
    {
      name: 'dust',
      value: '#5f80c7'
    },
    {
      name: 'sunset',
      value: '#faad14'
    },
    {
      name: 'volcano',
      value: '#f5686f'
    },
    {
      name: 'purple',
      value: '#9266f9'
    },
    {
      name: 'cyan',
      value: '#2bccce'
    },
    {
      name: 'green',
      value: '#33cc99'
    },
    {
      name: 'geekblue',
      value: '#32a2d4'
    }
  ];

  export default {
    name: 'EleProSetting',
    mixins: [Locale],
    emits: [
      'change-style',
      'change-color',
      'change-dark-mode',
      'change-weak-mode',
      'update:visible',
      'reset-setting'
    ],
    props: {
      // 是否显示, 支持.sync修饰
      visible: Boolean,
      // 顶栏风格
      headStyle: String,
      // 侧边栏风格
      sideStyle: String,
      // 布局风格
      layoutStyle: String,
      // 侧栏边菜单风格
      sideMenuStyle: String,
      // 内容区域宽度是否铺满
      bodyFull: Boolean,
      // 是否固定顶栏
      fixedHeader: Boolean,
      // 是否固定侧栏
      fixedSidebar: Boolean,
      // 是否固定主体
      fixedBody: Boolean,
      // logo是否自适应宽度
      logoAutoSize: Boolean,
      // 侧栏是否多彩图标
      colorfulIcon: Boolean,
      // 侧边栏是否只保持一个子菜单展开
      sideUniqueOpen: Boolean,
      // 是否开启页脚
      showFooter: Boolean,
      // 是否色弱模式
      weakMode: Boolean,
      // 是否开启多标签
      showTabs: Boolean,
      // 标签页风格
      tabStyle: String,
      // 是否暗黑模式
      darkMode: Boolean,
      // 当前主题色
      color: String,
      // 主题列表
      themes: Array,
      // 提示文字
      tips: String,
      // 是否显示颜色选择器
      colorPicker: Boolean,
      // 颜色选择器预设颜色
      predefineColors: Array,
      // 显示重置按钮
      resetButton: Boolean
    },
    data() {
      let chooseColor = this.color;
      if (
        this.color &&
        typeof this.themes !== 'undefined' &&
        this.themes !== null
      ) {
        (this.themes.length ? this.themes : DEFAULT_THEMES).forEach((t) => {
          if (this.color === t.value) {
            chooseColor = null;
          }
        });
      }
      return {
        // 默认的主题色
        defaultThemes: DEFAULT_THEMES,
        // 颜色选择器选中颜色
        chooseColor: chooseColor
      };
    },
    computed: {
      // 是否显示tips
      tipsVisible() {
        return typeof this.tips !== 'undefined' && this.tips !== null;
      }
    },
    methods: {
      /* 修改visible */
      updateVisible(value) {
        this.$emit('update:visible', value);
      },
      /* 重置设置 */
      resetSetting() {
        this.$emit('reset-setting');
      },
      /* 切换主题色 */
      changeColor(value) {
        if (value !== this.color) {
          this.$emit('change-color', value);
        }
      },
      /* 修改主题风格 */
      changeStyle(key, value) {
        this.$emit('change-style', { key: key, value: value });
      },
      setHeadStyle(value) {
        this.changeStyle('headStyle', value);
      },
      setSideStyle(value) {
        this.changeStyle('sideStyle', value);
      },
      setLayoutStyle(value) {
        this.changeStyle('layoutStyle', value);
      },
      setSideMenuStyle(value) {
        this.changeStyle('sideMenuStyle', value ? 'mix' : 'default');
      },
      setBodyFull(value) {
        this.changeStyle('bodyFull', value);
      },
      setFixedHeader(value) {
        this.changeStyle('fixedHeader', value);
      },
      setFixedSidebar(value) {
        this.changeStyle('fixedSidebar', value);
      },
      setFixedBody(value) {
        this.changeStyle('fixedBody', value);
        if (value) {
          document.body.style.width = null;
        }
      },
      setLogoAutoSize(value) {
        this.changeStyle('logoAutoSize', value);
      },
      setColorfulIcon(value) {
        this.changeStyle('colorfulIcon', value);
      },
      setSideUniqueOpen(value) {
        this.changeStyle('sideUniqueOpen', value);
      },
      setWeakMode(value) {
        this.$emit('change-weak-mode', value);
      },
      setDarkMode(value) {
        this.$emit('change-dark-mode', value);
      },
      setShowFooter(value) {
        this.changeStyle('showFooter', value);
        if (!value) {
          document.body.style.width = null;
        }
      },
      setShowTabs(value) {
        this.changeStyle('showTabs', value);
      },
      setTabStyle(value) {
        this.changeStyle('tabStyle', value);
      }
    }
  };
</script>

<style lang="scss">
  .ele-setting-wrapper {
    padding: 20px 18px;

    .ele-setting-title {
      font-size: 13px;
      margin-bottom: 15px;
    }

    /* 主题风格 */
    .ele-setting-theme > div {
      width: 52px;
      height: 36px;
      line-height: 1;
      font-size: 18px;
      border-radius: 3px;
      margin: 0 20px 30px 0;
      padding: 14px 0 0 24px;
      box-sizing: border-box;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
      display: inline-block;
      vertical-align: top;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      transition: background-color 0.2s;

      &:before,
      &:after,
      & > .ele-bg-primary {
        content: '';
        width: 100%;
        height: 10px;
        background: #fff;
        position: absolute;
        left: 0;
        top: 0;
        transition: background-color 0.2s;
      }

      &:after {
        width: 14px;
        height: 100%;
      }

      &.ele-side-dark:after,
      &.ele-head-dark:before,
      &.ele-layout-mix:before,
      &.ele-layout-mix:after {
        background: #001529;
      }

      &.ele-head-light:before,
      &.ele-head-dark:before,
      & > .ele-bg-primary {
        z-index: 1;
      }
    }

    /* 主题色选择 */
    .ele-setting-colors {
      color: #fff;
      margin-bottom: 20px;

      .ele-setting-color-item {
        width: 20px;
        height: 20px;
        line-height: 22px;
        border-radius: 2px;
        margin: 8px 8px 0 0;
        display: inline-block;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
        vertical-align: top;
        position: relative;
        text-align: center;
        cursor: pointer;
      }
    }

    /* 主题配置项 */
    .ele-setting-item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .setting-item-title {
        flex: 1;
        line-height: 28px;
      }

      .setting-item-control {
        line-height: 1;
        max-width: 95px;
      }
    }

    .el-divider {
      margin-bottom: 20px;
    }

    .el-alert + .ele-setting-button-group {
      margin-top: 15px;
    }
  }

  /* 适配暗黑模式 */
  .ele-setting-dark .ele-setting-theme > div {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);

    &:before,
    &:after,
    & > .ele-bg-primary {
      background: #1f1f1f;
    }

    &.ele-side-dark:after,
    &.ele-head-dark:before,
    &.ele-layout-mix:before,
    &.ele-layout-mix:after {
      background: #262626;
    }
  }

  /* 颜色选择器 */
  .ele-setting-color-picker.el-color-picker {
    height: auto;
    margin-top: 8px;

    .el-color-picker__trigger {
      padding: 0;
      width: 20px;
      height: 20px;
      border: none;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    }

    .el-color-picker__color {
      border: none;
    }

    .el-color-picker__color-inner {
      border-radius: 2px;
    }

    .el-color-picker__empty {
      background: linear-gradient(45deg, #00dbde 5%, #fc00ff 105%);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transform: none;
      border-radius: 2px;
      font-size: 0;
    }

    .el-color-picker__icon {
      font-size: 14px;
    }
  }
</style>
